<ng-container *ngTemplateOutlet="conteudoForm"></ng-container>

<!-- Template de conteúdo compartilhado -->
<ng-template #conteudoForm>
  <form [formGroup]="agendamentoForm" (ngSubmit)="salvarAgendamento()">
    <div class="grid p-fluid">
      <div class="col-12 lg:col-12">
        <lib-form-field
          [label]="'BARDO_AGENDA.ATENDIMENTO_DOMICILIO' | translate"
          controlName="isDomicilio"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="isDomicilio"
            [options]="opcoesDomicilio"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.SELECIONE_ATENDIMENTO_DOMICILIO' | translate"
          />
          } @else {
          <p-select
            formControlName="isDomicilio"
            [options]="opcoesDomicilio"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.SELECIONE_ATENDIMENTO_DOMICILIO' | translate"
            styleClass="w-full"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      @if (agendamentoForm.get('isDomicilio')?.value === true) {
      <div class="col-12 lg:col-12">
        <lib-form-field
          [label]="'BARDO_AGENDA.ENDERECO' | translate"
          controlName="endereco"
          [required]="true"
        >
          <input
            pInputText
            type="text"
            id="endereco"
            formControlName="endereco"
            maxlength="500"
            [placeholder]="'BARDO_AGENDA.ENDERECO_PLACEHOLDER' | translate"
            class="w-full"
          />
        </lib-form-field>
      </div>
      }

      @if ($estabelecimentoFechado() && !isEncaixe) {
      <div class="col-12 flex justify-content-center">
        <p-message
          severity="warn"
          icon="pi pi-clock"
          [text]="'BARDO_AGENDA.ESTABELECIMENTO_FORA_HORARIO' | translate"
          styleClass="w-full text-center"
        />
      </div>
      }

      <!-- Container para Cliente -->
      <div class="col-12 lg:col-12">
        @if (agendamento.id || agendamento.agendaId) {
          @if (agendamento.responsavelNome || agendamento.responsavelTelefone) {
          <!-- Reagendamento com Responsável + Dependente -->
          <div class="grid">
            <!-- Telefone do Responsável -->
            <div class="col-12 lg:col-6">
              <lib-form-field
                [label]="'BARDO_CLIENTES.TELEFONE_RESPONSAVEL' | translate"
                controlName="telefone"
                [required]="true"
              >
                <lib-phone-input
                  [value]="agendamentoForm.get('telefone')?.value ?? ''"
                  [disabled]="agendamentoForm.get('telefone')?.disabled ?? false"
                  (valueChange)="onTelefoneChange($event)"
                />
              </lib-form-field>
            </div>

            <!-- Nome do Responsável -->
            <div class="col-12 lg:col-6">
              <lib-form-field [label]="'BARDO_CLIENTES.NOME_RESPONSAVEL' | translate">
                <input
                  pInputText
                  type="text"
                  [value]="agendamento.responsavelNome"
                  disabled
                  class="w-full"
                />
              </lib-form-field>
            </div>

            <!-- Nome do Dependente (Paciente) -->
            <div class="col-12 lg:col-12">
              <lib-form-field
                [label]="'BARDO_CLIENTES.NOME_DEPENDENTE_PACIENTE' | translate: { termo: $nicho().cliente.singular }"
                controlName="nome"
                [required]="true"
              >
                <input
                  pInputText
                  type="text"
                  #nomeInput
                  id="nome"
                  formControlName="nome"
                  [placeholder]="'BARDO_CLIENTES.NOME_DEPENDENTE_PLACEHOLDER' | translate"
                  class="w-full"
                />
              </lib-form-field>
            </div>
          </div>
          } @else {
          <!-- Reagendamento sem Dependente (Titular) -->
          <div class="grid">
            <!-- Telefone (reagendamento sem dependente) -->
            <div class="col-12 lg:col-6">
              <lib-form-field
                [label]="'BARDO_CLIENTES.TELEFONE' | translate"
                controlName="telefone"
                [required]="true"
              >
                <lib-phone-input
                  [value]="agendamentoForm.get('telefone')?.value ?? ''"
                  [disabled]="agendamentoForm.get('telefone')?.disabled ?? false"
                  (valueChange)="onTelefoneChange($event)"
                />
              </lib-form-field>
            </div>

            <!-- Nome do Cliente -->
            <div class="col-12 lg:col-6">
              <lib-form-field
                [label]="'BARDO_CLIENTES.NOME_COMPLETO_DO' | translate: { termo: $nicho().cliente.singular }"
                controlName="nome"
                [required]="true"
              >
                <input
                  pInputText
                  type="text"
                  #nomeInput
                  id="nome"
                  formControlName="nome"
                  [placeholder]="'BARDO_CLIENTES.NOME_COMPLETO_DO' | translate: { termo: $nicho().cliente.singular }"
                  class="w-full"
                />
              </lib-form-field>
            </div>
          </div>
          }
        } @else {
          <!-- Novo Agendamento -->
          <div class="grid">
            <!-- Telefone (busca cliente no blur/enter) -->
            <div class="col-12 lg:col-6">
              <lib-form-field
                [label]="'BARDO_CLIENTES.TELEFONE' | translate"
                controlName="telefone"
                [required]="true"
              >
                <div
                  (focusout)="onPhoneFocusOut($event)"
                  (keydown.enter)="buscarCliente()"
                >
                  <lib-phone-input
                    [value]="agendamentoForm.get('telefone')?.value ?? ''"
                    [disabled]="agendamentoForm.get('telefone')?.disabled ?? false"
                    (valueChange)="onTelefoneChange($event)"
                  />
                </div>
              </lib-form-field>
            </div>

            <!-- Container for Name and Button -->
            <div class="flex align-items-center col-12 lg:col-6 gap-2">
              <!-- Nome do Cliente -->
              <div class="flex-grow-1">
                <lib-form-field
                  [label]="'BARDO_CLIENTES.NOME_COMPLETO_DO' | translate: { termo: $nicho().cliente.singular }"
                  controlName="nome"
                  [required]="true"
                >
                  <input
                    pInputText
                    type="text"
                    #nomeInput
                    id="nome"
                    formControlName="nome"
                    [placeholder]="'BARDO_CLIENTES.NOME_COMPLETO_DO' | translate: { termo: $nicho().cliente.singular }"
                    class="w-full"
                  />
                </lib-form-field>
              </div>

              <!-- Button Adicionar (apenas exibido quando o cliente não é encontrado para cadastro rápido) -->
              @if (!$desabilitarBotaoAdicionarCliente()) {
              <div class="flex-shrink-0 mt-3">
                <p-button
                  icon="pi pi-plus"
                  styleClass="p-button-outlined"
                  (onClick)="novoUsuarioRapido()"
                  [pTooltip]="'BARDO_CLIENTES.CADASTRAR_NOVO_TOOLTIP' | translate: { termo: $nicho().cliente.singular }"
                  tooltipPosition="top"
                />
              </div>
              }
            </div>
          </div>

          @if ($opcoesPacientes().length > 0) {
          <!-- Seleção de Cliente (Atendido por este agendamento) -->
          <div class="grid mt-2">
            <div class="col-12 lg:col-12">
              <lib-form-field [label]="'BARDO_CLIENTES.CLIENTE_ATENDIDO' | translate: { termo: $nicho().cliente.singular }" controlName="pacienteId">
                @if (deviceService.$isMobile()) {
                <lib-n-multiselect
                  [multiple]="false"
                  formControlName="pacienteId"
                  [options]="$opcoesPacientes()"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="'BARDO_CLIENTES.SELECIONE_QUEM_ATENDIDO' | translate"
                />
                } @else {
                <p-select
                  [options]="$opcoesPacientes()"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="pacienteId"
                  [placeholder]="'BARDO_CLIENTES.SELECIONE_QUEM_ATENDIDO' | translate"
                  styleClass="w-full"
                  [appendTo]="$dropdownAppendTo()"
                />
                }
              </lib-form-field>
            </div>

            @if (agendamentoForm.get('pacienteId')?.value === 'novo_paciente') {
            <div class="col-12 lg:col-6">
              <lib-form-field [label]="'BARDO_CLIENTES.NOME_NOVO_DEPENDENTE' | translate: { termo: $nicho().cliente.singular }" controlName="nomePacienteDependente" [required]="true">
                <input
                  pInputText
                  type="text"
                  formControlName="nomePacienteDependente"
                  [placeholder]="'BARDO_CLIENTES.INFORME_NOME_DEPENDENTE' | translate"
                  class="w-full"
                />
              </lib-form-field>
            </div>

            <div class="col-12 lg:col-6">
              <lib-form-field [label]="'BARDO_CLIENTES.DATA_NASCIMENTO_DEPENDENTE_LABEL' | translate" controlName="dataNascimentoPacienteDependente" [required]="true">
                @if (deviceService.$isMobile()) {
                <input pInputText type="date" formControlName="dataNascimentoPacienteDependente" class="w-full" />
                } @else {
                <p-datepicker
                  formControlName="dataNascimentoPacienteDependente"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/AAAA"
                  [showIcon]="true"
                  [maxDate]="dataMinima"
                  styleClass="w-full"
                  (onInput)="aplicarMascaraData($event)"
                  [appendTo]="$dropdownAppendTo()"
                />
                }
              </lib-form-field>
            </div>
            }
          </div>
          }
        }
      </div>

      @if (agendamento) {
      <div class="col-12 lg:col-12">
        <lib-form-field [label]="'BARDO_AGENDA.DATA' | translate" controlName="data" [required]="true">
          @if (deviceService.$isMobile()) {
          <input pInputText type="date" formControlName="data" class="w-full" />
          } @else {
          <p-datepicker
            formControlName="data"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            placeholder="DD/MM/AAAA"
            [iconDisplay]="'input'"
            styleClass="w-full"
            [minDate]="dataMinima"
            [disabledDays]="$diasDesabilitados()"
            [disabledDates]="$feriadosDesabilitados()"
            (input)="aplicarMascaraData($event)"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>
      }
      <!-- Serviços - Grid responsivo -->
      <div class="col-12 lg:col-6">
        <lib-form-field
          [label]="'BARDO_AGENDA.CATEGORIA_DE' | translate: { termo: $nicho().servico.plural }"
          controlName="tipoServico"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="tipoServico"
            [options]="tiposServicos"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.SELECIONE_CATEGORIA' | translate"
          />
          } @else {
          <p-select
            formControlName="tipoServico"
            id="tipoServico"
            [options]="tiposServicos"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.SELECIONE_CATEGORIA' | translate"
            [showClear]="true"
            styleClass="w-full"
            [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      <div class="col-12 lg:col-6">
        <lib-form-field
          [label]="$nicho().servico.plural"
          controlName="servico"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="servico"
            [options]="servicosFiltrados"
            optionLabel="label"
            optionValue="value"
            [placeholder]="$nicho().servico.placeholderSelecione"
          />
          } @else {
          <p-select
            formControlName="servico"
            [options]="servicosFiltrados"
            optionLabel="label"
            optionValue="value"
            [placeholder]="$nicho().servico.placeholderSelecione"
            [showClear]="true"
            styleClass="w-full"
            [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
            [appendTo]="$dropdownAppendTo()"
          >
            <ng-template let-servico pTemplate="item">
              <div
                class="flex justify-content-between align-items-center w-full gap-2"
              >
                <span>{{ servico.label }}</span>
                <span
                  style="font-size: 0.78rem; color: var(--p-text-muted-color)"
                  >{{ servico.duracao }}</span
                >
              </div>
            </ng-template>
            <ng-template let-servico pTemplate="selectedItem">
              <span
                >{{ servico.label }}
                <span
                  style="font-size: 0.78rem; color: var(--p-text-muted-color)"
                  >({{ servico.duracao }})</span
                ></span
              >
            </ng-template>
          </p-select>
          }
        </lib-form-field>
      </div>

      @if ($semProfissionalDisponivel()) {
      <div class="col-12 flex justify-content-center">
        <p-message
          severity="warn"
          icon="pi pi-user-minus"
          [text]="'BARDO_AGENDA.SEM_PROFISSIONAL_DISPONIVEL' | translate: { termo: ($nicho().profissional.singular | lowercase) }"
          styleClass="w-full text-center"
        />
      </div>
      } @if ($profissionalComAusencia()) {
      <div class="col-12 flex justify-content-center">
        <p-message
          severity="warn"
          icon="pi pi-calendar-times"
          [text]="'BARDO_AGENDA.PROFISSIONAL_AUSENCIA' | translate: { termo: $nicho().profissional.singular }"
          styleClass="w-full text-center"
        />
      </div>
      }

      <!-- Profissional e Horário -->
      <div class="col-12 lg:col-6">
        <lib-form-field
          [label]="$nicho().profissional.singular"
          controlName="profissional"
          [required]="true"
        >
          @if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="profissional"
            [options]="profissionaisFiltrados"
            optionLabel="label"
            optionValue="value"
            [placeholder]="$nicho().profissional.placeholderSelecione"
          />
          } @else {
          <p-select
            formControlName="profissional"
            [options]="profissionaisFiltrados"
            optionLabel="label"
            optionValue="value"
            [placeholder]="$nicho().profissional.placeholderSelecione"
            [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
            [showClear]="true"
            styleClass="w-full"
            [appendTo]="$dropdownAppendTo()"
          />
          }
        </lib-form-field>
      </div>

      <div class="col-12 lg:col-6">
        <lib-form-field [label]="'BARDO_AGENDA.HORARIO' | translate" controlName="horario" [required]="true">
          @if (isEncaixe) {
          <p-iconfield
            class="w-full cursor-pointer"
            tabindex="0"
            role="button"
            (click)="abrirModalSeletorHorario()"
            (keyup.enter)="abrirModalSeletorHorario()"
          >
            <input
              pInputText
              type="text"
              [value]="obterHorarioFormatadoEncaixe()"
              placeholder="00:00"
              readonly
              inputmode="none"
              tabindex="-1"
              (focus)="removerFocoInput($event)"
              class="w-full cursor-pointer text-center font-bold text-lg"
              style="background-color: var(--p-content-background, #ffffff);"
            />
            <p-inputicon styleClass="pi pi-clock text-primary" />
          </p-iconfield>
          } @else if (deviceService.$isMobile()) {
          <lib-n-multiselect
            [multiple]="false"
            formControlName="horario"
            [options]="horariosDisponiveis"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.HORARIO_PLACEHOLDER' | translate"
            (selectionChange)="onHorarioChange($event)"
          >
            <ng-template let-horario>
              <div
                class="horario-option"
                [class.reservado-item]="horario.slotStatus === 'reservado'"
                [class.conflito-item]="horario.slotStatus === 'conflito'"
                [class.almoco-item]="horario.slotStatus === 'almoco'"
              >
                {{ horario.label }}
                @if (horario.statusLabel) {
                <span>&nbsp;- {{ horario.statusLabel }}</span>
                } @if (horario.conflitoLabel) {
                <span>&nbsp;- {{ horario.conflitoLabel }}</span>
                }
              </div>
            </ng-template>
          </lib-n-multiselect>
          } @else {
          <p-select
            formControlName="horario"
            [options]="horariosDisponiveis"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'BARDO_AGENDA.HORARIO_PLACEHOLDER' | translate"
            [showClear]="true"
            styleClass="w-full"
            (onChange)="onHorarioChange($event)"
            [appendTo]="$dropdownAppendTo()"
            [emptyMessage]="'BARDO_AGENDA.NENHUM_RESULTADO' | translate"
          >
            <ng-template let-horario pTemplate="item">
              <div
                class="horario-option"
                [class.reservado-item]="horario.slotStatus === 'reservado'"
                [class.conflito-item]="horario.slotStatus === 'conflito'"
                [class.almoco-item]="horario.slotStatus === 'almoco'"
              >
                {{ horario.label }}
                @if (horario.statusLabel) {
                <span>&nbsp;- {{ horario.statusLabel }}</span>
                } @if (horario.conflitoLabel) {
                <span>&nbsp;- {{ horario.conflitoLabel }}</span>
                }
              </div>
            </ng-template>
          </p-select>
          }
        </lib-form-field>
      </div>

      <div class="col-12 lg:col-12">
        <lib-form-field [label]="'BARDO_AGENDA.OBSERVACOES' | translate" controlName="observacoes">
          <textarea
            pTextarea
            id="observacoes"
            formControlName="observacoes"
            [placeholder]="'BARDO_AGENDA.OBSERVACOES_PLACEHOLDER' | translate"
            class="w-full"
            rows="5"
            cols="30"
          ></textarea>
        </lib-form-field>
      </div>
    </div>
  </form>
</ng-template>

<!-- Template de Footer -->
<ng-template #footerTemplate>
  <div class="w-full">
    <p-button
      [label]="$labelButtonSalvar()"
      (onClick)="salvarAgendamento()"
      styleClass="p-button-primary w-full"
      icon="pi pi-check"
      [disabled]="agendamentoForm.invalid"
      [loading]="$isLoading()"
    />
  </div>
</ng-template>


<p-confirmDialog appendTo="body" [style]="{ width: '450px' }" />

<!-- Modal / Bottom Sheet de Seleção de Horário para Encaixe -->
@if (isEncaixe) {
  @if (deviceService.$isMobile() && $modalSeletorHorarioVisible()) {
  <lib-bottom-sheet
    [visible]="$modalSeletorHorarioVisible()"
    (visibleChange)="$modalSeletorHorarioVisible.set($event)"
    size="medium"
    [draggable]="true"
    [closeOnBackdrop]="true"
    [closeOnEscape]="true"
    [headerTemplate]="headerSeletorHorarioTpl"
    [footerTemplate]="footerSeletorHorarioTpl"
    (hide)="fecharModalSeletorHorario()"
  >
    <ng-container *ngTemplateOutlet="conteudoSeletorHorarioTpl"></ng-container>
  </lib-bottom-sheet>
  } @else {
  <p-dialog
    [header]="'BARDO_AGENDA.SELECIONAR_HORARIO' | translate"
    [visible]="$modalSeletorHorarioVisible()"
    (visibleChange)="$modalSeletorHorarioVisible.set($event)"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    [dismissableMask]="true"
    styleClass="n-modal-seletor-horario"
    [style]="{ width: '340px', maxWidth: '95vw' }"
    [appendTo]="'body'"
  >
    <ng-container *ngTemplateOutlet="conteudoSeletorHorarioTpl"></ng-container>
    <ng-template pTemplate="footer">
      <ng-container *ngTemplateOutlet="footerSeletorHorarioTpl"></ng-container>
    </ng-template>
  </p-dialog>
  }

  <ng-template #headerSeletorHorarioTpl>
    <div class="flex align-items-center gap-2">
      <i class="pi pi-clock text-primary text-xl"></i>
      <h3 class="m-0 text-lg font-semibold">{{ 'BARDO_AGENDA.SELECIONAR_HORARIO' | translate }}</h3>
    </div>
  </ng-template>

  <ng-template #conteudoSeletorHorarioTpl>
    <div class="flex flex-column align-items-center justify-content-center py-2">
      <div class="text-center mb-3">
        <span class="text-secondary text-sm block mb-1">{{ 'BARDO_AGENDA.HORARIO_SELECIONADO' | translate }}</span>
        <span class="text-3xl font-bold text-primary">
          {{ horarioTemporarioEncaixe | date:'HH:mm' }}
        </span>
      </div>

      <div class="flex justify-content-center w-full">
        <p-datepicker
          [(ngModel)]="horarioTemporarioEncaixe"
          [inline]="true"
          [timeOnly]="true"
          hourFormat="24"
          [showSeconds]="false"
          styleClass="w-full n-inline-timepicker"
        />
      </div>
    </div>
  </ng-template>

  <ng-template #footerSeletorHorarioTpl>
    <div class="flex justify-content-between gap-2 w-full pt-2">
      <p-button
        [label]="'BARDO_AGENDA.CANCELAR' | translate"
        icon="pi pi-times"
        severity="secondary"
        [outlined]="true"
        (click)="fecharModalSeletorHorario()"
        styleClass="w-full"
      />
      <p-button
        [label]="'BARDO_AGENDA.CONFIRMAR' | translate"
        icon="pi pi-check"
        severity="primary"
        (click)="confirmarHorarioEncaixe()"
        styleClass="w-full"
      />
    </div>
  </ng-template>
}
